module.exports = __webpack_public_path__ + "img/압구정역 네일샵.d9bcad78.png";